<template>
    <div class="content-body">
        <div class="row">
            <div class="col-12">
                <div class="top__header" :style="!suggestion ? 'grid-template-columns: 30px 1fr' : ''">
                    <span class="back" @click="back()">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z" fill="black"/>
                        </svg>
                    </span>
                    <span class="header__title" v-if="suggestion">{{ suggestion.customer }} ({{ suggestion.product }})</span>
                    <div class="header__btn" v-if="suggestion">
                        <button type="button" @click="archived()" v-if="suggestion.archived_at == null" class="btn btn-secondary">
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 3.5C4.05109 3.5 3.86032 3.57902 3.71967 3.71967C3.57902 3.86032 3.5 4.05109 3.5 4.25V14.75C3.5 14.9489 3.57902 15.1397 3.71967 15.2803C3.86032 15.421 4.05109 15.5 4.25 15.5H14.75C14.9489 15.5 15.1397 15.421 15.2803 15.2803C15.421 15.1397 15.5 14.9489 15.5 14.75V6.81066L12.1893 3.5H4.25ZM2.65901 2.65901C3.08097 2.23705 3.65326 2 4.25 2H12.5C12.6989 2 12.8897 2.07902 13.0303 2.21967L16.7803 5.96967C16.921 6.11032 17 6.30109 17 6.5V14.75C17 15.3467 16.7629 15.919 16.341 16.341C15.919 16.7629 15.3467 17 14.75 17H4.25C3.65326 17 3.08097 16.7629 2.65901 16.341C2.23705 15.919 2 15.3467 2 14.75V4.25C2 3.65326 2.23705 3.08097 2.65901 2.65901Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.25C5 9.83579 5.33579 9.5 5.75 9.5H13.25C13.6642 9.5 14 9.83579 14 10.25V16.25C14 16.6642 13.6642 17 13.25 17C12.8358 17 12.5 16.6642 12.5 16.25V11H6.5V16.25C6.5 16.6642 6.16421 17 5.75 17C5.33579 17 5 16.6642 5 16.25V10.25Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75 2C6.16421 2 6.5 2.33579 6.5 2.75V5.75H11.75C12.1642 5.75 12.5 6.08579 12.5 6.5C12.5 6.91421 12.1642 7.25 11.75 7.25H5.75C5.33579 7.25 5 6.91421 5 6.5V2.75C5 2.33579 5.33579 2 5.75 2Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 3.5C4.05109 3.5 3.86032 3.57902 3.71967 3.71967C3.57902 3.86032 3.5 4.05109 3.5 4.25V14.75C3.5 14.9489 3.57902 15.1397 3.71967 15.2803C3.86032 15.421 4.05109 15.5 4.25 15.5H14.75C14.9489 15.5 15.1397 15.421 15.2803 15.2803C15.421 15.1397 15.5 14.9489 15.5 14.75V6.81066L12.1893 3.5H4.25ZM2.65901 2.65901C3.08097 2.23705 3.65326 2 4.25 2H12.5C12.6989 2 12.8897 2.07902 13.0303 2.21967L16.7803 5.96967C16.921 6.11032 17 6.30109 17 6.5V14.75C17 15.3467 16.7629 15.919 16.341 16.341C15.919 16.7629 15.3467 17 14.75 17H4.25C3.65326 17 3.08097 16.7629 2.65901 16.341C2.23705 15.919 2 15.3467 2 14.75V4.25C2 3.65326 2.23705 3.08097 2.65901 2.65901Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10.25C5 9.83579 5.33579 9.5 5.75 9.5H13.25C13.6642 9.5 14 9.83579 14 10.25V16.25C14 16.6642 13.6642 17 13.25 17C12.8358 17 12.5 16.6642 12.5 16.25V11H6.5V16.25C6.5 16.6642 6.16421 17 5.75 17C5.33579 17 5 16.6642 5 16.25V10.25Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75 2C6.16421 2 6.5 2.33579 6.5 2.75V5.75H11.75C12.1642 5.75 12.5 6.08579 12.5 6.5C12.5 6.91421 12.1642 7.25 11.75 7.25H5.75C5.33579 7.25 5 6.91421 5 6.5V2.75C5 2.33579 5.33579 2 5.75 2Z" stroke="white"/>
                            </svg>
                            <span>Archiver</span>
                        </button>

                        <a :href="mailTo" class="btn btn-primary">
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2.75C13.1716 2.75 12.5 3.42157 12.5 4.25C12.5 5.07843 13.1716 5.75 14 5.75C14.8284 5.75 15.5 5.07843 15.5 4.25C15.5 3.42157 14.8284 2.75 14 2.75ZM11 4.25C11 2.59315 12.3431 1.25 14 1.25C15.6569 1.25 17 2.59315 17 4.25C17 5.90685 15.6569 7.25 14 7.25C12.3431 7.25 11 5.90685 11 4.25Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 8C4.17157 8 3.5 8.67157 3.5 9.5C3.5 10.3284 4.17157 11 5 11C5.82843 11 6.5 10.3284 6.5 9.5C6.5 8.67157 5.82843 8 5 8ZM2 9.5C2 7.84315 3.34315 6.5 5 6.5C6.65685 6.5 8 7.84315 8 9.5C8 11.1569 6.65685 12.5 5 12.5C3.34315 12.5 2 11.1569 2 9.5Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 13.25C13.1716 13.25 12.5 13.9216 12.5 14.75C12.5 15.5784 13.1716 16.25 14 16.25C14.8284 16.25 15.5 15.5784 15.5 14.75C15.5 13.9216 14.8284 13.25 14 13.25ZM11 14.75C11 13.0931 12.3431 11.75 14 11.75C15.6569 11.75 17 13.0931 17 14.75C17 16.4069 15.6569 17.75 14 17.75C12.3431 17.75 11 16.4069 11 14.75Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.59939 10.5204C6.80793 10.1625 7.26712 10.0415 7.625 10.25L12.125 12.875C12.4829 13.0835 12.6039 13.5427 12.3954 13.9006C12.1869 14.2585 11.7277 14.3796 11.3698 14.171L6.86978 11.546C6.5119 11.3375 6.39084 10.8783 6.59939 10.5204Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3947 5.09921C12.6035 5.45696 12.4828 5.91622 12.125 6.125L7.63104 8.92053C7.27329 9.12931 6.81403 9.00854 6.60526 8.65079C6.39648 8.29304 6.51725 7.83378 6.875 7.625L11.369 4.82947C11.7267 4.62069 12.186 4.74146 12.3947 5.09921Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2.75C13.1716 2.75 12.5 3.42157 12.5 4.25C12.5 5.07843 13.1716 5.75 14 5.75C14.8284 5.75 15.5 5.07843 15.5 4.25C15.5 3.42157 14.8284 2.75 14 2.75ZM11 4.25C11 2.59315 12.3431 1.25 14 1.25C15.6569 1.25 17 2.59315 17 4.25C17 5.90685 15.6569 7.25 14 7.25C12.3431 7.25 11 5.90685 11 4.25Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 8C4.17157 8 3.5 8.67157 3.5 9.5C3.5 10.3284 4.17157 11 5 11C5.82843 11 6.5 10.3284 6.5 9.5C6.5 8.67157 5.82843 8 5 8ZM2 9.5C2 7.84315 3.34315 6.5 5 6.5C6.65685 6.5 8 7.84315 8 9.5C8 11.1569 6.65685 12.5 5 12.5C3.34315 12.5 2 11.1569 2 9.5Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 13.25C13.1716 13.25 12.5 13.9216 12.5 14.75C12.5 15.5784 13.1716 16.25 14 16.25C14.8284 16.25 15.5 15.5784 15.5 14.75C15.5 13.9216 14.8284 13.25 14 13.25ZM11 14.75C11 13.0931 12.3431 11.75 14 11.75C15.6569 11.75 17 13.0931 17 14.75C17 16.4069 15.6569 17.75 14 17.75C12.3431 17.75 11 16.4069 11 14.75Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.59939 10.5204C6.80793 10.1625 7.26712 10.0415 7.625 10.25L12.125 12.875C12.4829 13.0835 12.6039 13.5427 12.3954 13.9006C12.1869 14.2585 11.7277 14.3796 11.3698 14.171L6.86978 11.546C6.5119 11.3375 6.39084 10.8783 6.59939 10.5204Z" stroke="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3947 5.09921C12.6035 5.45696 12.4828 5.91622 12.125 6.125L7.63104 8.92053C7.27329 9.12931 6.81403 9.00854 6.60526 8.65079C6.39648 8.29304 6.51725 7.83378 6.875 7.625L11.369 4.82947C11.7267 4.62069 12.186 4.74146 12.3947 5.09921Z" stroke="white"/>
                            </svg>
                            <span>Partager</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card__suggestion" v-if="suggestion">
            <h4>Suggestions</h4>
            <div class="first__bloc mb-2 mt-2">
                <div>
                    <div><strong>Nom</strong></div>
                    <span>{{ suggestion.last_name }}</span>
                </div>
                <div>
                    <div><strong>Prénom(s)</strong></div>
                    <span>{{ suggestion.first_name }}</span>
                </div>
                <div>
                    <div><strong>Date de soumission</strong></div>
                    <span>{{ suggestion.created_at }}</span>
                </div>
            </div>
            <div class="second__bloc mb-2">
                <div><strong>Produit concerné</strong></div>
                <span>{{ suggestion.product }}</span>
            </div>
            <div class="last__bloc">
                <div><strong>Message</strong></div>
                <p>{{ suggestion.description }}</p>
            </div>
        </div>
        <div class="alert alert-warning mt-2" role="alert" v-else>
            <div class="alert-body">
                Suggestion non trouvée ou données invalides.
            </div>
        </div>
    </div>
</template>

<script>
var $this;
import axios from 'axios';
import { api } from '../../../helpers/shared'
export default {
    props: ['detail'],
    data: () => ({
        suggestion: {},
        mailTo: ''
    }),
    mounted(){
        try {
            this.suggestion = this.detail ? JSON.parse(this.detail) : null;
            if (this.suggestion) {
                this.mailTo = "mailto:"+this.suggestion.email+"?subject="+this.suggestion.title+"&body="+this.suggestion.description
            }
        } catch (e) {
            console.error("Erreur lors du parsing de la suggestion", e);
            this.suggestion = null;
        }
    },
    created(){
        $this = this
    },
    methods:{
        back(){
            this.$router('/administration/suggestions')
        },
        archived(){
            $this.$swal.fire({
                title: 'Êtes-vous sûr de vouloir archiver cette suggestion ?',
                text: "Cette action est irréversible",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, archiver',
                cancelButtonText: 'Annuler',
                customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    axios.post(api('administration/suggestions/archived'), {key: $this.suggestion.id, uuid: $this.suggestion.uuid}).then(() => {
                        $this.suggestion.archived_at = 'archived'
                        $this.$swal.fire({
                            icon: 'success',
                            title: 'Opération réussie!',
                            text: 'Cette suggestion a été archivée',
                            customClass: {
                            confirmButton: 'btn btn-success'
                            }
                        });
                    }).catch((error) => {
                        this.loadingData = false;
                        if (error.response.status === 401){
                            $this.$toast.global.error({message: "Votre connexion a expiré"});
                        }else {
                        }
                    })
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .header__title{
        font-size: 22px;
        line-height: 30px;
        color: #5E5873;
    }
    .back{
        cursor: pointer;
    }
    .top__header {
        display: grid;
        grid-template-columns: 30px 1fr 1fr;
        .header__btn {
            justify-self: end;
        }
    }
    .card__suggestion{
        padding: 20px;
        min-height: 280px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        margin-top: 20px;
        .first__bloc{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
</style>
